import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const SVG = styled.svg`
  & path {
    stroke: ${({ color }) => themeGet(`colors.${color}`)};
  }
`;

const PeopleSVG = ({ color }) => (
  <SVG
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M8.50024 10.8185V9.81848C8.50024 9.28805 8.28953 8.77934 7.91446 8.40427C7.53939 8.0292 7.03068 7.81848 6.50024 7.81848H2.50024C1.96981 7.81848 1.4611 8.0292 1.08603 8.40427C0.710958 8.77934 0.500244 9.28805 0.500244 9.81848V10.8185"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.49976 5.81848C5.60433 5.81848 6.49976 4.92305 6.49976 3.81848C6.49976 2.71391 5.60433 1.81848 4.49976 1.81848C3.39519 1.81848 2.49976 2.71391 2.49976 3.81848C2.49976 4.92305 3.39519 5.81848 4.49976 5.81848Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4998 10.8185V9.81854C11.4994 9.37541 11.3519 8.94493 11.0804 8.5947C10.8089 8.24447 10.4288 7.99433 9.99976 7.88354"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00024 1.88354C8.43045 1.9937 8.81176 2.2439 9.08406 2.5947C9.35636 2.9455 9.50417 3.37696 9.50417 3.82104C9.50417 4.26513 9.35636 4.69658 9.08406 5.04739C8.81176 5.39819 8.43045 5.64839 8.00024 5.75854"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVG>
);

export default PeopleSVG;
